import { Divider, Space } from "antd";

function ProductsPageV2() {
  return (
    <Space direction={"horizontal"}>
      <Space direction={"vertical"}>
        Categories
      </Space>
      <Divider type={"vertical"} />
      <Space direction={"vertical"}>
        Products
      </Space>
    </Space>
  );
}

export default ProductsPageV2;
